import React from 'react';
import {ButtonProps} from '@material-ui/core';

import {BlueButton} from '../../../blue-button/blue-button.styled';
import {DialogActionsStyled} from './modal-footer.styled';

export type ButtonsBarProps = {
    buttons: Array<FooterButtonProps>
}

export type FooterButtonProps =
    & ButtonProps
    & {
    labelText?: string
    ['data-testid']?: string
}

export const ModalFooter = ({ buttons }: ButtonsBarProps) => {
    return (
        <DialogActionsStyled>
            {buttons.map((
                { labelText, ...restButtonProps }, index) => {
                return (
                    <BlueButton
                        key={`modal-footer-${index}-${labelText}`}
                        data-testid={'FooterButton'}
                        disableElevation
                        variant="contained"
                        {...restButtonProps}
                    >
                        {labelText}
                    </BlueButton>
                );
            })}
        </DialogActionsStyled>
    );
};
